/** @format */
import { css } from 'styled-components';

import { smallMobile, smallTablet } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

export const styles = () => css`
    background-color: var(--colors-surface-primary);

    .quantity-controls {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: var(--layout-spacing-24);
        ${theme.typography.body_small_highlight}

        button[disabled] {
            opacity: 0.5;
        }
    }

    .save-for-later {
        background-color: var(--colors-surface-secondary)
        padding: var(--layout-spacing-12);
        width: 100%;
        display: flex;
        border-radius: 0.4rem;
        gap: var(--layout-spacing-8);
        align-items: center;
        margin-top: var(--layout-spacing-16);
    }

    ${smallTablet(css`
        .quantity-controls {
            margin-top: var(--layout-spacing-16);

            label {
                margin-right: auto;
                margin-left: 6rem;
            }
        }
    `)}

    ${smallMobile(css`
        .quantity-controls {
            label {
                margin-left: 0;
            }
        }
    `)}
`;
